import { AxiosRequestConfig } from 'axios';

import { Auth0Credentials } from '@futrli/shared-services/authenticator/auth0/types';

import { AWSRequestConfig, Signer } from '../../signer';

export type Auth0SignerConfig = Record<string, unknown>;

export class Auth0Signer extends Signer<Auth0SignerConfig, AWSRequestConfig, Auth0Credentials> {
  public sign(requestConfig: AxiosRequestConfig, credentials: Auth0Credentials): AWSRequestConfig {
    if (!credentials.jwtToken) {
      throw new Error('JWT token is missing in credentials');
    }

    const signedConfig = {
      ...requestConfig,
      host: window.__env__.HOST,
      service: window.__env__.AWS_SERVICE,
      region: window.__env__.AWS_REGION,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      cleanHeaders: () => {},
      getConfig: () => {
        return {
          ...requestConfig,
          headers: {
            ...requestConfig.headers,
            Authorization: credentials.jwtToken
          },
          host: window.__env__.HOST,
          service: window.__env__.AWS_SERVICE,
          region: window.__env__.AWS_REGION
        };
      }
    };

    signedConfig.headers = {
      ...signedConfig.headers,
      Authorization: credentials.jwtToken
    };

    return (signedConfig as unknown) as AWSRequestConfig;
  }
}

/** Singer Sigleton instance */
let _instance: Signer<Auth0SignerConfig, AWSRequestConfig, Auth0Credentials> | undefined;

if (!_instance) {
  _instance = new Auth0Signer({});
}

const auth0Signer = _instance;

export { auth0Signer };
